export interface IAccordionItem {
  title: string;
  description: string;
  onClick?: (text: string) => void
}
